<section>
  <h1>{{ "PAGE_NOT_FOUND.404_PAGE_NOT_FOUND" | translate }}</h1>
  <a mat-button routerLink="/" color="primary">
    {{ "PAGE_NOT_FOUND.GO_TO_HOMEPAGE" | translate }}
  </a>
</section>
